/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonContextCto } from '../../models/person-context-cto';

export interface GetPersons$Plain$Params {
  Email?: string;
  FirstName?: string;
  LastName?: string;
  ApiUserId?: string;
  PersonGuid?: string;
  PersonId?: number;
  ApiUserCompanyId?: string;
  CompanyId?: number;
  CompanyGuid?: string;
}

export function getPersons$Plain(http: HttpClient, rootUrl: string, params?: GetPersons$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PersonContextCto>>> {
  const rb = new RequestBuilder(rootUrl, getPersons$Plain.PATH, 'get');
  if (params) {
    rb.query('Email', params.Email, {});
    rb.query('FirstName', params.FirstName, {});
    rb.query('LastName', params.LastName, {});
    rb.query('ApiUserId', params.ApiUserId, {});
    rb.query('PersonGuid', params.PersonGuid, {});
    rb.query('PersonId', params.PersonId, {});
    rb.query('ApiUserCompanyId', params.ApiUserCompanyId, {});
    rb.query('CompanyId', params.CompanyId, {});
    rb.query('CompanyGuid', params.CompanyGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PersonContextCto>>;
    })
  );
}

getPersons$Plain.PATH = '/person/search';
